import PropTypes from 'prop-types'

export const shapePaginator = PropTypes.shape({
  count: PropTypes.number,
  end: PropTypes.number,
  endIndex: PropTypes.number,
  nextPage: PropTypes.func,
  offset: PropTypes.number,
  page: PropTypes.number,
  previousPage: PropTypes.func,
  reset: PropTypes.func,
  result: PropTypes.arrayOf(PropTypes.object),
  start: PropTypes.number,
  startIndex: PropTypes.number,
  updateOffset: PropTypes.func,
  updatePage: PropTypes.func,
})

export const shapeConfigurationItem = PropTypes.shape({
  deviceId: PropTypes.string,
  deviceSubtype: PropTypes.string,
  selectedRevenue: PropTypes.string,
  selectedXpediteRevenueCenter: PropTypes.string,
  selectedSingleRevenue: PropTypes.string,
  configuration: PropTypes.shape({
    receiptPrinterUuid: PropTypes.string,
    esKey: PropTypes.string,
    storeId: PropTypes.string,
    terminalId: PropTypes.string,
    uatUrl: PropTypes.string,
    prodUrl: PropTypes.string,
    host: PropTypes.string,
    controlledPrinterUuids: PropTypes.string,
  }),
})
